import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-[#132C53] text-white mt-20" data-id="element-942">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-943">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-944">
          <div data-id="element-945">
            <h3 className="text-lg font-bold mb-4" data-id="element-946">Cautlocuință.ro</h3>
            <p className="text-gray-300 text-sm" data-id="element-947">
              Ecosistemul complet pentru profesioniștii din real estate
            </p>
          </div>
          <div data-id="element-948">
            <h4 className="text-sm font-semibold mb-4" data-id="element-949">Linkuri utile</h4>
            <ul className="space-y-2" data-id="element-950">
              <li data-id="element-951">
                <Link to="/" className="text-gray-300 hover:text-white text-sm transition-colors" data-id="element-952">
                  Training
                </Link>
              </li>
              <li data-id="element-953">
                <Link to="/despre" className="text-gray-300 hover:text-white text-sm transition-colors" data-id="element-954">
                  Despre
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-955">
            <h4 className="text-sm font-semibold mb-4" data-id="element-956">Legal</h4>
            <ul className="space-y-2" data-id="element-957">
              <li data-id="element-958">
                <a href="#" className="text-gray-300 hover:text-white text-sm transition-colors" data-id="element-959">
                  Termeni și condiții
                </a>
              </li>
              <li data-id="element-960">
                <a href="#" className="text-gray-300 hover:text-white text-sm transition-colors" data-id="element-961">
                  Politică de confidențialitate
                </a>
              </li>
              <li data-id="element-962">
                <a href="#" className="text-gray-300 hover:text-white text-sm transition-colors" data-id="element-963">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center" data-id="element-964">
          <p className="text-gray-400 text-sm" data-id="element-965">
            © {new Date().getFullYear()} Cautlocuință.ro. Toate drepturile
            rezervate.
          </p>
        </div>
      </div>
    </footer>;
}